angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.offerDetailsController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi', 'virtoCommerce.catalogModule.items', 'platformWebApp.uiGridHelper', 'platformWebApp.ui-grid.extension', 'platformWebApp.dialogService', 
        function ($scope, bladeNavigationService, marketplaceApi, catalogProducts, uiGridHelper, gridOptionExtension, dialogService) {
            $scope.uiGridConstants = uiGridHelper.uiGridConstants;
            var blade = $scope.blade;
            $scope.gridOptions = [];

            function initializeBlade(data) {
                blade.currentEntity = angular.copy(data);
                blade.originalEntity = data;

                if (!blade.sellerProduct) {
                    catalogProducts.getByIds({ ids: blade.currentEntity.productId }, (data) => {
                        if (data && data.length > 0) {
                            blade.product = data[0];
                        }
                    });
                }

                blade.isLoading = false;
            }

            blade.refresh = function (parentRefresh) {
                blade.isLoading = true;
                marketplaceApi.getOfferById({ offerId: blade.currentEntity.id }, function (data) {
                    initializeBlade(data);
                });

                if (parentRefresh) {
                    blade.parentBlade.offersRefresh();
                }
            };

            blade.toolbarCommands = [
                {
                    name: "platform.commands.save", icon: 'fas fa-save',
                    executeMethod: saveChanges,
                    canExecuteMethod: canSave
                },
                {
                    name: "platform.commands.reset", icon: 'fa fa-undo',
                    executeMethod: function () {
                        angular.copy(blade.originalEntity, blade.currentEntity);
                    },
                    canExecuteMethod: isDirty
                },
                {
                    name: "platform.commands.delete", icon: 'fas fa-trash-alt',
                    executeMethod: deleteOffer,
                    canExecuteMethod: function () {
                        return true;
                    }
                }
            ];

            blade.onClose = function (closeCallback) {
                bladeNavigationService.showConfirmationIfNeeded(isDirty(), canSave(), blade, saveChanges, closeCallback, "marketplace.dialogs.offer-save.title", "marketplace.dialogs.offer-save.message");
            };

            $scope.setForm = function (form) { $scope.formScope = form; };

            function isDirty() {
                return !angular.equals(blade.currentEntity, blade.originalEntity);
            }

            function canSave() {
                return isDirty() && $scope.formScope && $scope.formScope.$valid;
            }

            function saveChanges() {

                marketplaceApi.changeState({
                    offerId: blade.currentEntity.id,
                    isActive: blade.currentEntity.isActive,
                }, function () {
                    blade.refresh(true);
                });
            }

            function deleteOffer() {
                var dialog = {
                    id: "confirmDeleteItem",
                    itemCount: 1,
                    callback: function (remove) {
                        if (remove) {
                            bladeNavigationService.closeChildrenBlades(blade);
                            blade.isLoading = true;

                            marketplaceApi.deleteOffers({ ids: blade.currentEntity.id }, () => {
                                blade.isLoading = false;
                                blade.parentBlade.offersRefresh();
                                $scope.bladeClose();
                            });


                        }
                    }
                }
                dialogService.showDialog(dialog, 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/dialogs/deleteOffer-dialog.tpl.html', 'platformWebApp.confirmDialogController');
            }

            $scope.setGridOptions = function (gridId, gridOptions) {
                $scope.gridOptions[gridId] = gridOptions;
                gridOptionExtension.tryExtendGridOptions(gridId, gridOptions);

                gridOptions.onRegisterApi = function (gridApi) {
                    $scope.gridApi = gridApi;
                    $scope.gridApi.grid.gridHeight = 120;
                };
            };

            blade.refresh();
        }
    ]);
